// **React Imports
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// **MUI Imports
import { Box } from '@mui/material'

// **Store Imports
import { store } from './store'
import { Provider } from 'react-redux'

// **Context Imports
import { SettingsProvider } from './context/setting'
import { SocketProvider } from './context/socket'
import MeetingProvider from './context/meeting'

// **Component Imports
import App from './App'

// **Theme Imports
import ThemeComponent from './theme/ThemeComponent'
import MediapipeProvider from './context/media-pipe'

//Event Emitter Class
class EventEmitter {
  constructor() {
    this.events = {}
  }

  on(eventName, listener) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(listener)
  }

  off(eventName, listenerToRemove) {
    if (!this.events[eventName]) return

    this.events[eventName] = this.events[eventName].filter(
      (listener) => listener !== listenerToRemove
    )
  }

  emit(eventName, data) {
    const listeners = this.events[eventName]
    if (listeners) {
      listeners.forEach((listener) => listener(data))
    }
  }
}

window.eventEmitter = new EventEmitter()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <SocketProvider>
        <MeetingProvider>
          <MediapipeProvider>
            <SettingsProvider>
              <ThemeComponent>
                <Box className="main-container">
                  <App />
                </Box>
              </ThemeComponent>
            </SettingsProvider>
          </MediapipeProvider>
        </MeetingProvider>
      </SocketProvider>
    </Provider>
  </BrowserRouter>
)
